import axios from 'axios';
import Cookies from 'js-cookie';

export const refreshAccessToken = async () => {
  const refreshToken = Cookies.get('refresh_token');
  if (!refreshToken) {
    console.error('No refresh token found');
    return null;
  }

  try {
    const formData = new URLSearchParams();
    formData.append('grant_type', 'refresh_token');
    formData.append('client_id', process.env.REACT_APP_KEYCLOAK_CLIENT_ID);
    formData.append('client_secret', process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET);
    formData.append('refresh_token', refreshToken);

    const response = await axios.post(
      `${process.env.REACT_APP_KEYCLOAK_URL}/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/protocol/openid-connect/token`, // DEV
      // `${process.env.REACT_APP_KEYCLOAK_URL_UAT}/realms/${process.env.REACT_APP_KEYCLOAK_REALM_UAT}/protocol/openid-connect/token`, //UAT
      formData.toString(), // to handle 415 unsupprted media type 
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );

    const { access_token, refresh_token } = response.data;

    Cookies.set('access_token', access_token);
    Cookies.set('refresh_token', refresh_token);

    return access_token;
  } catch (error) {
    console.error('Error refreshing token:', error);
    return null;
  }
};
